import { atom } from "recoil";
import { ConnectionStatus } from "../../../constants/enums";
import { ObjectValues } from "../../../util/utilTypes";


export const connectionStatusAtom = atom<ObjectValues<typeof ConnectionStatus>>({
  key: "connectionStatusAtom",
  default: ConnectionStatus.DISCONNECTED
})
